import { FC } from 'react';

import { UserAvatar, UserPopover } from '@bonusly/common-user-popover';
import { Flex, Link, Text } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { formatDisplayDate } from '../../utils/date';

export interface AnnouncementHeaderProps {
	createdById: string;
	startDate: string;
}

export const AnnouncementHeader: FC<AnnouncementHeaderProps> = ({ createdById, startDate }) => {
	const recognizeURL = useBuildRecognizeURL();
	const formattedDate = formatDisplayDate(startDate);

	return (
		<Flex mb={2} alignItems="center" justifyContent="space-between">
			<UserPopover userId={createdById}>
				<Link href={recognizeURL(`/company/users/${createdById}`)} _hover={{ textDecoration: 'none' }}>
					<UserAvatar userId={createdById} />
				</Link>
			</UserPopover>

			<Text color="text.softest" fontSize={50} fontWeight="normal" lineHeight={5}>
				{formattedDate}
			</Text>
		</Flex>
	);
};
